var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"input-value":_vm.value,"loading":_vm.loading,"disabled":_vm.loading},on:{"change":function($event){return _vm.onValueChanged($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }